import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss'],
})
export class SearchModalComponent {
  @Input() title: string;

  @Input() message: string;

  @Input() placeholder = 'Enter guest name';

  @Input() cardTitle = 'Guest name';

  public name: string;

  constructor(private modalCtrl: ModalController) {}

  public search() {
    const cleanedName = (this.name || '').trim();
    if (!cleanedName) {
      return;
    }
    this.modalCtrl.dismiss({ name: cleanedName });
  }

  public cancel() {
    this.modalCtrl.dismiss();
  }
}
